export const config = {
	snackBar: {
		timeout: -1
	},
	icon: {
		class: 'mr-2'
	},
	btn: {
		text: true
	}
};
